module.exports = __webpack_public_path__ + "img/tarot-major-arcana-19.fe4b465f.png";